module.exports = __webpack_public_path__ + "static/media/giphy03.af6c5876.mp4";